import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center flex-col gap-4 bg-white bg-opacity-90 z-1000"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Adding payment method", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Your card will be charged for $1 to confirm payment method ", -1)
const _hoisted_4 = { class: "flex justify-between mt-8" }

import { StripeCardElement } from '@stripe/stripe-js';
import {
	useLoading,
	useToggle,
	UiButton,
	UiCardDivider,
	UiLoader
} from '@/ui-kit';
import { nextTick, onMounted, ref } from 'vue';
import { useStripe } from '../use-stripe';
import UiFormError from '@/ui-kit/UiForm/UiFormError.vue';
import { useToast } from 'vue-toastification';
import { sleep } from '@/utils';
import { usePaymentMethodsState } from '../use-payment-methods.state';
import { AxiosError } from 'axios';
import { usePaymentMethods } from '../use-payment-methods';
import { useCompanyProfile } from '@/account';

declare const rewardful: any;


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPaymentMethodForm',
  setup(__props, { expose }) {

const { createCardElement, createPaymentMethod } =
	useStripe();
const { isOpened, toggleOpened } = useToggle();
const cardContainerRef = ref<HTMLDivElement>();
const state = usePaymentMethodsState();
const { loading, toggleLoading } = useLoading();

const card = ref<StripeCardElement>();

onMounted(async () => {
	if (!cardContainerRef.value) {
		return;
	}
	card.value = await createCardElement(
		cardContainerRef.value
	);
});

async function openDialog() {
	error.value = '';
	toggleOpened(true);
	await nextTick();
	if (!card.value) {
		card.value = await createCardElement(
			cardContainerRef.value!
		);
	} else {
		card.value?.clear();
	}
}

function closeDialog() {
	toggleOpened(false);
}

const error = ref('');
const { userProfile } = useCompanyProfile();

const onError = (e: AxiosError) => {
	if (!e.response || !e.response.data) {
		return;
	}

	if (e.response.data.error || e.response.data.message) {
		error.value =
			e.response.data.error ||
			e.response.data.message;
	}

	if (e.response.data.errors) {
		error.value =
			e.response.data.errors['paymentMethod'][0] ||
			'';
	}
};

async function addPaymentMethod() {
	error.value = '';
	toggleLoading(true);
	try {
		const result = await createPaymentMethod(
			card.value!
		);
		if (result && result.error) {
			error.value = result.error.message as string;
		} else {
			const { success } = useToast();
			await sleep(3);
			await state.loadPaymentMethods();
			if (typeof rewardful !== 'undefined') {
				rewardful('convert', {
					email: userProfile.value?.email
				});
			}
			success(
				'Payment method was successfully added.'
			);
			toggleOpened(false);
		}
	} catch (e) {
		onError(e as AxiosError);
	} finally {
		toggleLoading(false);
	}
}

expose({
	openDialog
});

return (_ctx: any,_cache: any) => {
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    closeOnClickModal: !_unref(loading),
    closeOnPressEscape: !_unref(loading),
    showClose: !_unref(loading),
    customClass: "is-small",
    onClosed: closeDialog,
    modelValue: _unref(isOpened)
  }, {
    default: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(UiLoader))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(UiCardDivider), { title: "Add payment method" }),
      _hoisted_3,
      _createElementVNode("div", {
        class: "h-8",
        ref_key: "cardContainerRef",
        ref: cardContainerRef
      }, null, 512),
      _createVNode(UiFormError, {
        class: "mt-4",
        errorMessage: error.value
      }, null, 8, ["errorMessage"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(UiButton), {
          onClick: closeDialog,
          disabled: _unref(loading),
          type: "button",
          theme: "primary-outlined"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(UiButton), {
          onClick: addPaymentMethod,
          loading: _unref(loading)
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add payment method")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["closeOnClickModal", "closeOnPressEscape", "showClose", "modelValue"]))
}
}

})